import { useRef, useState } from "react";
import { ImagePlus } from "lucide-react";
import { toast } from "sonner";
import { API, formatApiErrorDetail } from "@/lib/api";

const ImageUpload = ({ onUploaded }) => {
  const inputRef = useRef(null);
  const [busy, setBusy] = useState(false);

  const onChange = async (e) => {
    const file = e.target.files?.[0];
    if (!file) return;
    setBusy(true);
    try {
      const fd = new FormData();
      fd.append("file", file);
      const { data } = await API.post("/admin/upload", fd, {
        headers: { "Content-Type": "multipart/form-data" },
      });
      onUploaded(data.url);
      toast.success("Imagen subida y enlazada a la portada");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail));
    } finally {
      setBusy(false);
      e.target.value = "";
    }
  };

  return (
    <>
      <input
        ref={inputRef}
        type="file"
        accept="image/*"
        className="hidden"
        onChange={onChange}
        data-testid="image-upload-input"
      />
      <button
        type="button"
        onClick={() => inputRef.current?.click()}
        disabled={busy}
        data-testid="image-upload-button"
        className="flex shrink-0 items-center gap-2 rounded-full border border-edge px-4 py-2 font-display text-sm font-bold uppercase tracking-wider text-slate-300 transition-colors hover:border-crimson hover:text-white disabled:opacity-50"
      >
        <ImagePlus className="h-4 w-4" /> {busy ? "Subiendo..." : "Subir imagen"}
      </button>
    </>
  );
};

export default ImageUpload;
